import { render } from "./MultiDocumentForm.vue?vue&type=template&id=47070c0a&scoped=true"
import script from "./MultiDocumentForm.vue?vue&type=script&lang=js"
export * from "./MultiDocumentForm.vue?vue&type=script&lang=js"

import "./MultiDocumentForm.vue?vue&type=style&index=0&id=47070c0a&scoped=true&lang=css"

import exportComponent from "/Users/derem1991/workspace/newear/frontend/kajot/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47070c0a"]])

export default __exports__